import React, {useState, useEffect} from 'react'
import _ from 'lodash'
import { Button, Popover, Switch, Typography, Icon, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment'
import { useIntl } from 'src/common/razzle-platform-translate'
import AddressFilter from 'src/common/razzle-platform-map/components/filters/AddressFilter'
import PriceFilter from 'src/common/razzle-platform-map/components/filters/PriceFilter'
import CategoryFilter from 'src/common/razzle-platform-map/components/filters/CategoryFilter'
import RadiusFilter from 'src/common/razzle-platform-map/components/filters/RadiusFilter'
import SpecificityFilter from 'src/common/razzle-platform-map/components/filters/product/SpecificityFilter'
import MoreFilter from 'src/common/razzle-platform-map/components/filters/product/MoreFilter'
import { AVAILABILITY_FILTER_ACTIVE } from 'src/common/razzle-platform-map/configs'
import { TagsFilterButton } from 'src/common/razzle-platform-map/components/TagsFilterButton'


let AvailabilityFilter
let AVAILABILITY_DATE_STRING_FORMAT

try {
    AvailabilityFilter = require('src/common/razzle-platform-reservation/Filters/AvailabilityFilter').default
    AVAILABILITY_DATE_STRING_FORMAT = require('src/common/razzle-platform-reservation/configs').AVAILABILITY_DATE_STRING_FORMAT
} catch (error) {}


const useStyles = makeStyles(theme => ({
    filterButton: {
        background: '#ffffff',
        color: '#000000',
        '&:hover': {
            background: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.primary.contrastText} !important`,
            borderColor: `${theme.palette.primary.main} !important`
        },
    },
    filterButtonActive: {
        background: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
    },
    container: {
        maxWidth: matches => matches ? '90%' : '100%',
        '& > div': {
            '& > button': {
                padding: '5px 12px'
            }
        },
        '& .address-filter': {
            maxWidth: 'none',
            '& > .container': {
                display: 'flex',
                '& > div > button': {
                    height: '40px',
                },
            },
        },
        '& p': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '14px',
            textTransform: 'capitalize'
        },
        '& > div > div > button': {
            width: '100%',
            height: '40px',
        },
    },
    toggleMap: {
        alignSelf: 'flex-end',
        justifyContent: 'center',
        maxWidth: '10%',
        '& p': {
            fontSize: '13px',
        },
    },
}))



function FiltersRow(props) {
    const [anchorEl, setAnchorEl] = useState(null)
    const [anchorElId, setAnchorElId] = useState(null)

    const [filtersUpdated, setFiltersUpdated] = useState(false)
    const [filters_, setFilters_] = useState({})
    const [cleared, setCleared] = useState(false)
    const [selectedSpecificity, setSelectedSpecificity] = useState({})

    const { formatMessage } = useIntl()
    const matches = useMediaQuery('(max-width: 1100px)')
        
    const {
        categories, mapView, toggleMap, states, cities, citiesInProgress, mapSize, centerMap,
        specificities, filters, setFilter, applyFilter, cancelFilter, isFilteringByCountry, setIsFilteringByCountry
    } = props
    const classes = useStyles(matches)

    useEffect(() => {
        // apply the filter after close the popup
        if (anchorElId === null) {
            applyFilter()
        }
    }, [anchorElId])

    const checkCategorySpeificities = (rowSpecs) => {
        if(filters['category.id'] && categories.length > 0 && !rowSpecs){
            let category = undefined

            if(typeof filters['category.id'] === 'string'){
                category = categories.filter(cat => cat.id === filters['category.id'])[0]
            }else{
                filters['category.id'].forEach(id => {
                    category = categories.filter(cat => cat.id === id)[0]
                })
            }

            return category ? addSpecificities(category) : []
        }else{
            const parentCategory = categories.filter(category => !category.parentCategory)[0]
            if(parentCategory){
                return addSpecificities(parentCategory, rowSpecs)
            }else{
                return []
            }
        }
    }

    const addSpecificities = (category, rowSpecs) => {
        let specResults = []
        category.deepCategorySpecificities?.forEach(spec => {
            const specificity = props.specificities.filter(item => spec.specificity.id === item.id)[0]
            if (rowSpecs) {
                specResults.push(specificity)
            } else {
                if (category.parentCategory) {
                    specResults.push(specificity)
                }
            }
        })

        return _.uniqWith(specResults, (arrVal, othVal) => arrVal.id === othVal.id)
    }


    const handleChange = (event, multi, isChecked, immediatelyFilter=false) => {
        if(multi){
            setFilter({[event.target.name]: _.isArray(event.target.value) ? event.target.value : [event.target.value]}, immediatelyFilter)
        }else{
            setFilter({[event.target.name]: isChecked ? undefined : event.target.value}, immediatelyFilter)
        }
    }

    const clearFilter = (key) => {
        if(Array.isArray(key)) {
            cancelFilter(key)
        }else{
            cancelFilter([key])
        }
        // closePopup()
        setCleared(true)
    }


    const closePopup = () => {
        setAnchorEl(null)
        setAnchorElId(null)
    }

    const openPopup = event => {
        setAnchorEl(event.currentTarget)
        setAnchorElId(event.currentTarget.id)
    }

    const checkCollapse = (event, isChecked, category) => {
        setCleared(false)
        let nextState = {...filters_}
        const children = toggleCollapse(category)
        // If the collapse is not checked, add all of the categories of the selected category to the filter
        // If it's checked, remove each category fro mthe filter

        if(!isChecked){
            children.forEach(item => nextState = {
                ...nextState,
                [event.target.name]: nextState[event.target.name] ? [...nextState[event.target.name], item] : [item]
            })
            setFilters_(nextState)

        }else{
            children.forEach(item => nextState = {
                ...nextState,
                [event.target.name]: _.filter(nextState[event.target.name], (elem) => elem !== item)
            })
            setFilters_(nextState)
        }
    }

    const toggleCollapse = (category) =>{
        let returnedChildren = []
        const children = category.subCategories.map(item => item)
        children.forEach(item => {
            const currentCategory = categories.filter(elem => elem.id === item.id)[0]
            returnedChildren.push(currentCategory.id)
            toggleCollapse(currentCategory)
        })
        return returnedChildren
    }

    const checkSelectedSpecFilters = (specificities, filters) => {
        let selected = false
        let keys = []
        specificities.forEach(spec => {
            if(spec.type === 'date'){
                keys.push(`productSpecificities.date_${spec.id}`)
            }else if(spec.type === 'm_list'){
                keys.push(`productSpecificities.choices_${spec.id}`)
            }else{
                keys.push(`productSpecificities.choice_${spec.id}`)
            }
        })

        keys.forEach(key => {
            if(filters.hasOwnProperty(key) && filters[key]){
                selected = true
            }
        })

        return selected
    }


    const open = Boolean(anchorEl)
    const buttonSpecificities = (specificities && checkCategorySpeificities(true)) || []
    const moreSpecificities = (specificities && checkCategorySpeificities(false).filter(item => buttonSpecificities.indexOf(item) < 0)) || []


    return (
        <div className="flex justify-between items-center p-4 pl-8 pt-0">
            <div className={"flex flex-wrap " + classes.container}>
                <div className="mb-2 address-filter">
                    <div className="container">
                        <AddressFilter
                            values={filters}
                            clearFilter={clearFilter}
                            centerMap={centerMap}
                            mapSize={mapSize}
                            mapView={mapView}
                            isMobile={false}
                            setFilter={setFilter}
                            applyFilter={applyFilter}
                            isFilteringByCountry={isFilteringByCountry}
                            setIsFilteringByCountry={setIsFilteringByCountry}
                        />
                        {!mapView && !isFilteringByCountry && <div className="mr-2">
                            <Button
                                id="radiusFilter"
                                onClick={event => openPopup(event)}
                                variant="outlined"
                                size="medium"
                                className={classNames(
                                    (anchorElId === 'radiusFilter') || filters.radius ? classes.filterButtonActive : '',
                                    classes.filterButton,
                                )}
                            >
                                {<Typography>{formatMessage({ id: 'Radius', defaultMessage: 'Radius'})}{filters.radius ? `: ${filters.radius} ${formatMessage({ id: 'km', defaultMessage: 'km' })}` : ''}</Typography>}
                            </Button>
                        </div>}
                        { AvailabilityFilter && AVAILABILITY_FILTER_ACTIVE &&
                    <div className="mr-2">
                        <Button
                            id="availabilityFilter"
                            onClick={event => openPopup(event)}
                            variant="outlined"
                            size="medium"
                            className={classNames(
                                (anchorElId === 'availabilityFilter') || (filters['availabilities.leStartDate'] && filters['availabilities.geEndDate']) ? classes.filterButtonActive : '',
                                classes.filterButton,
                            )}
                        >
                            {(filters['availabilities.leStartDate'] && filters['availabilities.geEndDate']) ?
                                <>{filters['availabilities.geEndDate']}<Icon className="text-lg ml-2 mr-2">arrow_forward</Icon>{filters['availabilities.leStartDate']}</> :
                                <Typography>{formatMessage({ id: 'Disponibilité', defaultMessage: 'Disponibilité'})}</Typography>}
                        </Button>
                    </div>
                }

                {categories &&
                    <div className="mr-2">
                        <Button
                            id="categoryFilter"
                            onClick={event => openPopup(event)}
                            variant="outlined"
                            size="medium"
                            className={classNames(
                                (anchorElId === 'categoryFilter') || (filters['category.id'] && filters['category.id'].length > 0) ? classes.filterButtonActive : '',
                                classes.filterButton
                            )}
                        >
                            {filters['category.id'] && Array.isArray(filters['category.id']) && filters['category.id'].length > 1 ?
                                <>
                                    <Typography>{formatMessage({ id: 'Category', defaultMessage: 'Category'})}</Typography>
                                    <span className="mx-1"> - </span>
                                    {filters['category.id'].length}
                                </>
                                : filters['category.id'] && filters['category.id'].length === 1 ?
                                    categories.length > 0 && categories.filter(item => item.id === filters['category.id'][0])[0].name
                                    : <Typography >{formatMessage({ id: 'Category', defaultMessage: 'Category'})}</Typography>
                            }
                        </Button>
                    </div>
                }
                    </div>
                </div>

                <div className="flex flex-wrap">

                {/* <div className="xl:mr-4 lg:mr-2 mr-1">
                    <Button
                    id="priceFilter"
                    onClick={event => openPopup(event)}
                    variant="outlined"
                    size="medium"
                    className={classNames(
                        (anchorElId === 'priceFilter') || (filters.gePrice || filters.lePrice) ? classes.filterButtonActive : '',
                        classes.filterButton,
                        )}
                        >
                        {(filters.gePrice && filters.lePrice) ?
                            `${filters.gePrice} - ${filters.lePrice}`
                            : filters.gePrice ?
                            <><Icon className="text-lg mr-2">arrow_upward</Icon> {filters.gePrice}</>
                            : filters.lePrice ?
                                    <><Icon className="text-lg mr-2">arrow_downward</Icon> {filters.lePrice}</>
                                    : <Typography>{formatMessage({ id: 'Price', defaultMessage: 'Price'})}</Typography>
                                }
                                </Button>
                </div> */}
                
                <TagsFilterButton
                    classes={classes}
                    setFilter={setFilter}
                    filters={filters}
                
                />

                {buttonSpecificities.map(spec => {
                    const specType = spec.type === 'm_list' ? 'choices' : spec.type === 'date' ? 'date' : 'choice'
                    const filterSpecSelected = filters.hasOwnProperty(`productSpecificities.${specType}_${spec.id}`) && filters[`productSpecificities.${specType}_${spec.id}`]
                    return (
                        <div className="mr-2 mb-2" key={spec.id}>
                            <Button
                                id="specificityFilter"
                                onClick={event => {
                                    if (spec.type === 'str') {
                                        if (filterSpecSelected) {
                                            clearFilter(`productSpecificities.${specType}_${spec.id}`)
                                        } else {
                                            setFilters_({
                                                ...filters,
                                                [`productSpecificities.${specType}_${spec.id}`]: spec.id
                                            })
                                        }
                                        applyFilter()
                                    } else {
                                        setSelectedSpecificity(spec)
                                        openPopup(event)
                                    }
                                }}
                                variant="outlined"
                                size="medium"
                                className={classNames(
                                    (anchorElId === "specificityFilter" && selectedSpecificity.id === spec.id) ||
                                        (filters[`productSpecificities.${specType}_${selectedSpecificity.id}`] && filters[`productSpecificities.${specType}_${selectedSpecificity.id}`].length > 0 && selectedSpecificity.id === spec.id) ||
                                        (filterSpecSelected && filterSpecSelected.length > 0) ? classes.filterButtonActive : '',
                                    classes.filterButton
                                )}
                                >
                                <Typography>{spec.name}</Typography>
                            </Button>
                        </div>
                    )
                })}
                {specificities && specificities.length > 0 && <div className="mr-2 mb-2">
                    <Button
                        id="moreFilter"
                        onClick={event => setAnchorElId(event.currentTarget.id)}
                        variant="outlined"
                        size="medium"
                        className={classNames(
                            (anchorElId === 'moreFilter') || (filters.fullname || filters.geCreatedAt || filters.leCreatedAt || checkSelectedSpecFilters(moreSpecificities, filters)) ?
                            classes.filterButtonActive : '',
                            classes.filterButton
                            )}
                    >
                        <Typography>{formatMessage({ id: 'More Filters', defaultMessage: 'More Filters'})}</Typography>
                    </Button>
                </div>}
                </div>
            </div>

            {!matches && mapView ? null : <div className={"flex flex-wrap items-center " + classes.toggleMap}>
                <Switch
                    onChange={toggleMap}
                    checked={mapView}
                    size="medium"
                    color="primary"
                    inputProps={{
                        style: { left: 0, opacity: 0 }
                    }}
                />
                <Typography variant="button" className="flex align-middle">
                    <Typography className="text-center">{formatMessage({ id: 'Show Map', defaultMessage: 'Show Map' })}</Typography>
                </Typography>
            </div>}

            {open && anchorElId && <Popover
                id="simple-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={closePopup}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {anchorElId === 'radiusFilter' && 
                    <RadiusFilter
                        values={filters}
                        handleChange={handleChange}
                    />
                }
                {anchorElId === 'specificityFilter' &&
                    <SpecificityFilter
                        handleChange={handleChange}
                        values={filters}
                        clearFilter={clearFilter}
                        save={() => {
                            applyFilter()
                            closePopup()
                        }}
                        close={closePopup}
                        specificity={selectedSpecificity}
                    />
                }

                {/* {anchorElId === 'priceFilter' &&
                    <PriceFilter
                        values={filters}
                        handleChange={handleChange}
                        clearFilter={clearFilter}
                        save={() => {
                            applyFilter()
                            closePopup()
                        }}
                    />
                } */}

                { AvailabilityFilter && anchorElId === 'availabilityFilter' &&
                    <AvailabilityFilter
                        onSave={() => {
                            applyFilter()
                            closePopup()
                        }}
                        startDate={filters['availabilities.geEndDate'] ? moment(filters['availabilities.geEndDate'], AVAILABILITY_DATE_STRING_FORMAT) : null}
                        endDate={filters['availabilities.leStartDate'] ? moment(filters['availabilities.leStartDate'], AVAILABILITY_DATE_STRING_FORMAT) : null}
                        onChange={({startDate, endDate, ...rest}) => {
                            setFilter({
                                ...startDate ? {'availabilities.geEndDate': startDate} : null ,
                                ...endDate ? {'availabilities.leStartDate':  endDate} : null,
                                ...rest,
                            })
                        }}
                        // In the database, we have availabilities that have multiple days in the interval start-end_date
                        // if we use the filter start_date <= availabilities <= end_date this will get only the availabilities that are in the interval but if we have an availability that start with the correct day and ends with a date bigger than the end_date that availability will not be included
                        // to resolve this issue we adjusted the filter to get availabilities start_date less than the selected end date and availabilities end_date greater than the selected start date                        
                        onClear={() => clearFilter(Object.keys(filters).filter(key => _.startsWith(key, 'availabilities')), true)}
                        extraAvailabilityFilters={props.extraAvailabilityFilters}
                        filters={filters}
                        clearFilter={clearFilter}
                    />
                }

                {anchorElId === 'categoryFilter' &&
                    <CategoryFilter
                        categories={categories}
                        values={filters}
                        handleChange={handleChange}
                        clearFilter={clearFilter}
                        save={() => {
                            applyFilter()
                            closePopup()
                        }}
                        checkCollapse={checkCollapse}
                    />
                }

            </Popover>}
                {anchorElId === 'moreFilter' &&
                    <MoreFilter
                        values={filters}
                        handleChange={handleChange}
                        clearFilter={clearFilter}
                        save={() => {
                            applyFilter()
                            closePopup()
                        }}
                        close={closePopup}
                        setFilter={setFilter}
                        specificities={moreSpecificities}
                    />
                }
        </div>

    )
}

export default FiltersRow
